/* Email landing pages (/pages/visit, /pages/shop-the-room, /pages/staying-on). Oct 2026 email program.
   1. Releases Klaviyo's body scroll lock (its popup is hidden on these pages by CSS).
   2. /pages/staying-on: records one Klaviyo "Re-permission Stay" event per browser for the dormant
      re-permission emails (07). With the email link's _kx exchange id it posts to the Client Events API right
      away, because the site loads klaviyo.js late (60 s on phones). Without _kx it queues the event for
      klaviyo.js, which records it only for an identified visitor. No PII is read from or added to the URL. */
(() => {
  const root = document.querySelector('[data-wnfe-page]');
  if (!root) return;

  const lockClass = 'klaviyo-prevent-body-scrolling';
  const release = () => { if (document.body.classList.contains(lockClass)) document.body.classList.remove(lockClass); };
  release();
  new MutationObserver(release).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  if (root.getAttribute('data-wnfe-page') !== 'staying-on') return;
  const KEY = 'wnfe-repermission-stay';
  try { if (localStorage.getItem(KEY)) return; } catch (e) { /* storage blocked: still record once for this view */ }
  const mark = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* optional */ } };
  const params = new URLSearchParams(location.search);
  const props = { source: '07', page: 'staying-on' };
  const campaign = (params.get('utm_campaign') || '').slice(0, 100);
  if (campaign) props.campaign = campaign;
  const kx = params.get('_kx');
  if (kx) {
    try {
      fetch('https://a.klaviyo.com/client/events?company_id=RmGNgB', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Re-permission Stay' } } },
          profile: { data: { type: 'profile', attributes: { _kx: kx } } }
        } } })
      }).then(r => { if (r.ok) mark(); }, () => {});
    } catch (e) { /* network or CSP: the email click itself is still recorded by Klaviyo */ }
  } else {
    // Not marked as sent: klaviyo.js drops the event for an anonymous visitor, so a later _kx visit can still record it.
    try { if (sessionStorage.getItem(KEY)) return; sessionStorage.setItem(KEY, '1'); } catch (e) { /* optional */ }
    const kl = window.klaviyo || (window._klOnsite = window._klOnsite || []);
    try { kl.push(['track', 'Re-permission Stay', props]); } catch (e) { /* Klaviyo is optional */ }
  }
})();
